export default "__VITE_ASSET__5fc8a2fa__"